import React from 'react';
import { DriverDetailsProps } from './driver-details.props';
import { Flex, Text } from 'common/common-components.styled';
import { useGetUser } from '../../../hooks/react-query/use-get-user/use-get-user';

const DriverDetails = ({ driverId }: DriverDetailsProps) => {
  const { userData } = useGetUser(driverId, false);

  return (
    <Flex align='flex-end' direction='column'>
      <Text color='grey600' size='12'>
        {userData?.fullname || <i>Nicht angegeben</i>}
      </Text>
      <Text color='grey600' size='12'>
        {userData?.address1_line1 || <i>Nicht angegeben</i>}
      </Text>
      <Text color='grey600' size='12'>
        {userData?.address1_postalcode || userData?.address1_city ? (
          `${userData?.address1_postalcode || ''} ${userData?.address1_city || ''}`
        ) : (
          <i>Nicht angegeben</i>
        )}
      </Text>
    </Flex>
  );
};

export default DriverDetails;
